export const JobDates_REQUEST = "JobDates_REQUEST";
export const JobDates_SUCCESS = "JobDates_SUCCESS";
export const JobDates_FAIL = "JobDates_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const SET_MESSAGE = "SET_MESSAGE";
